import {
    redirect,
    useActionData,
    useLoaderData,
    useParams,
    useRevalidator,
    useSubmit,
    useSearchParams
} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import {useForm} from "react-hook-form";
import {Autoform} from "../../../../components/forms/autoform";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {parseISO} from "date-fns";
import {Box} from "@mui/material";
import {showSnackbar} from "../../../../components/snackbarUtils";
import PageTitle from "../../../../components/PageTitle";

export async function loader({request, params}) {
    const id = params.price_id;
    const searchParams = new URL(request.url).searchParams;
    const children_id = searchParams.get("children_id");
    const price_id = searchParams.get("price_id");
    //const form = (await api.get(`api/rate/child/${rate_id}/${children_id}/`)).data.form;
    const form = (await api.get(`api/empty/empty/0/666/${price_id}/`)).data.form;
    return {form};
}

export async function action({request, params}) {
    const formData = await request.formData();
    const id = params.price_id;
    const obj_id = params.object_id;
    const price_ID = formData.get("price_ID");
    // Функция для преобразования формата даты в YYYY-MM-DD
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split(".");
        if (parts.length === 3) {
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        return dateStr; // Если формат уже верный, не меняем
    };

    // Преобразование дат перед отправкой
    const updatedFormData = new FormData();
    formData.forEach((value, key) => {
        if (key === "default_period_start" || key === "default_period_end") {
            updatedFormData.append(key, formatDate(value));
        } else {
            updatedFormData.append(key, value);
        }
    });

    try {
        const response = await api.patch(`api/empty/empty/0/666/${price_ID}/`, updatedFormData)
        if (response.status === 200) {
            showSnackbar("Ціна успішно оновлено!", "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });

            setTimeout(() => {
                window.location.href = `/object/${obj_id}/tariffs`; // Перенаправление через 1 сек
            }, 3000);
        } else {
            showSnackbar('Помилка при оновлені ціни', 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    } catch (e) {
        showSnackbar(`Помилка при оновлені ціни ${e}`, 'error', {
            sx: {backgroundColor: "#ff0000", color: "white"}
        });
        return {error: e}
    }
    return null;
}

export default function ObjectPriceEdit() {
    const {object_id, price_id} = useParams();
    const [searchParams] = useSearchParams();
    const submit = useSubmit();
    const actionData = useActionData();
    const children_id = searchParams.get("children_id");
    const price_ID = searchParams.get("price_id");

    const revalidator = useRevalidator();
    const {form} = useLoaderData();
    const formHook = useForm();
    const handleSubmitForm = (data) => {
        const formData = jsonToFormData({...data, price_ID: price_ID});
        submit(formData, {
            method: 'post'
        })
    }

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/tariffs`}
            title={{text: 'Змінити ціну'}}
        >
            <PageTitle title={`Редагування ціни: ${price_ID || price_id || "ID"}`} />
            <Autoform
                revalidator={revalidator}
                fields={form}
                formName='HotelPrice'
                formHook={formHook}
                onSubmit={handleSubmitForm}
            />
            {actionData?.response && (<Box>
                {JSON.stringify(actionData.response?.data)}
            </Box>)}
        </ModalUrlWindow>
    )
}
